import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { UsuarioLoginResponse } from '../../responses/platform/usuario-login.response';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { PublicationProfileRequest } from '../../../constants/user-publication-profile.constants';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient,
    @Inject(DOCUMENT) private _doc: Document,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    super();
  } 

  public signIn(email:string, password:string, ip:string): Observable<UsuarioLoginResponse> {
    const userAuthRequest = {
      email: email,
      password: password,
      ip: ip,
    };

    return this.httpClient
      .post<UsuarioLoginResponse>(environment.urlApiPlatform + 'Auth', userAuthRequest)
      .pipe(catchError(this.handleError));
  }

  public register(email:string, password:string, ip:string, phone:string, name:string, cpf:string, publicationProfile?: PublicationProfileRequest): Observable<UsuarioLoginResponse> {
    const userAuthRequest = {
      name: name,
      email: email,
      password: password,
      phone:phone,
      cpf:cpf,
      ip: ip,
      ...(publicationProfile ?? {}),
    };

    return this.httpClient
      .post<UsuarioLoginResponse>(environment.urlApiPlatform + 'Auth/newUser', userAuthRequest)
      .pipe(catchError(this.handleError));
  }

  updateToken(userLoginResponse: UsuarioLoginResponse): void {
    this._doc.defaultView?.sessionStorage?.setItem('token', JSON.stringify(userLoginResponse));
  }

  getToken(): string {
    const token = window?.sessionStorage?.getItem('token');
    if (token) {
      const userLoginResponse: UsuarioLoginResponse = JSON.parse(token);
      return userLoginResponse.token;
    }
    return '';
  }

  getUserInfos(): UsuarioLoginResponse {
    if (isPlatformBrowser(this.platformId)) {
      let token:string|null = window?.sessionStorage?.getItem('token');
      if(token)
        return JSON.parse(token?token:'');
    }
    
    return new UsuarioLoginResponse();
  }

  logout(): void {
    this._doc.defaultView?.sessionStorage?.removeItem('token');
    this.router.navigate(['/']);
  }

  isAuthenticated(): boolean {
    return !this._doc.defaultView?.sessionStorage?.getItem('token') ? false : true;
  }
}
